import { FunctionComponent } from "react";

import { BaseReportPage } from "../EngagementReportPage/BaseReportPage";

const ProjectRequestPage: FunctionComponent = () => {
    return <BaseReportPage />;
};

export default ProjectRequestPage;
